import type { ProductItemThemeSettings } from '@providers/ThemeProvider/types';

import type { ProductPriceSetting } from '@/features/filter-product-list/product-list/product-item/ProductPrice';

export type ProductPricePropsMapSettings = Pick<
  ProductPriceSetting,
  'showCentAsSuperscript' | 'showMultiVariantPrice' | 'showSavingDisplay' | 'compareAtPricePosition'
>;

export const useConnectProductPrice = (settings: ProductItemThemeSettings) => {
  const productPriceSettings = settings.productInfo?.elements?.price;
  const textAlign = settings.productInfo?.textAlign;

  if (!productPriceSettings) return { props: {} };

  const {
    priceColor,
    priceFontFamily,
    priceFontStyle,
    priceFontWeight,
    priceFontSize,
    salePriceColor,
    salePriceFontFamily,
    salePriceFontStyle,
    salePriceFontWeight,
    salePriceFontSize,
    compareAtPriceColor,
    compareAtPriceFontFamily,
    compareAtPriceFontStyle,
    compareAtPriceFontWeight,
    compareAtPriceFontSize,
    savingDisplayColor,
    ...rest
  } = productPriceSettings;

  const props = {
    ...rest,
    priceStyle: {
      color: priceColor,
      fontFamily: priceFontFamily,
      fontStyle: priceFontStyle,
      fontWeight: priceFontWeight,
      fontSize: priceFontSize,
    },
    salePriceStyle: {
      color: salePriceColor,
      fontFamily: salePriceFontFamily,
      fontStyle: salePriceFontStyle,
      fontWeight: salePriceFontWeight,
      fontSize: salePriceFontSize,
    },
    comparePriceStyle: {
      color: compareAtPriceColor,
      fontFamily: compareAtPriceFontFamily,
      fontStyle: compareAtPriceFontStyle,
      fontWeight: compareAtPriceFontWeight,
      fontSize: compareAtPriceFontSize,
    },
    savingStyle: {
      color: savingDisplayColor,
    },
    textAlign,
  };

  return {
    props,
  };
};
